import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Home from "./Home";
import Dashboard from "../components/dashboard/Dashboard";
import PrimaryMaster from "./masters/primarymaster/PrimaryMaster";
import Account from "./masters/accounts/Account";
//import Account from "./crm/accounts/Account";
//import AccountView from "./crm/accounts/AccountView";
import AccountView from "./masters/accounts/AccountMasterView";
import UserMaster from "./masters/usermaster/UserMaster";
import Opportunities from "./crm/opportinities/Opportunity";
import OpportunityView from "./crm/opportinities/OpportunityView";
import Lead from "./crm/leads/Lead";
import LeadView from "./crm/leads/LeadView";
import Product from "./masters/product/Product";
import ProductMasterView from "./masters/product/ProductMasterView";
import Quotation from "./crm/Quotation/Quotation";
import QuotationView from "./crm/Quotation/QuotationView";
// import CountryWise from "./crm/QuotationAnalysis";
import QuotationAnalysis from "./crm/QuotationAnalysis/QuotationAnalysis"
// import QuotationLostAnalysis from "./crm/QuotationLostAnalysis";
import QProductWise from "./crm/QuotationAnalysis/QProductWise";
import QTeamWise from "./crm/QuotationAnalysis/QTeamWise";
import QuotationLostAnalysis from "./crm/QuotationLostAnalysis/QuotationLostAnalysis";
import SalesOrder from "./crm/SalesOrder/SalesOrder";
import SOMasterView from "./crm/SalesOrder/SOMasterView";
import CRMTest from "./crm/CRMTest";
import Activities from "./crm/Activities";
//import MessageCenter from "./crm/MessageCenter";
import MessageCenter from "./crm/MessageCenter/MessageCenter";
// import CustomerCompaints from "./crm_service/CustomerCompaints";
import CustomerCompaints from "./crm_service/CustomerCompaints/CustomerCompaints";
import CreateCustomerCompaints from "./crm_service/CustomerCompaints/CreateCustomerCompaints";
import Sales from "./Sales/Sales";
//import DeliveryChallan from "./Sales/DeliveryChallan";
import DeliveryChallan from "./Sales/DeliveryChallan/DeliveryChallan";
import DCMasterView from "./Sales/DeliveryChallan/DCMasterView";
import DispatchManagement from "./Sales/DispatchManagement";
import Invoice from "./Sales/Invoice";
import SalesAnalysis from "./Sales/SalesAnalysis/SalesAnalysis";
import QCountryWise from "./crm/QuotationAnalysis/QCountryWise";
import CountryWise from "./Sales/SalesAnalysis/CountryWise";
import ProductWise from "./Sales/SalesAnalysis/ProductWise";
import SalesTeamWise from "./Sales/SalesAnalysis/SalesTeamWise";
import FGInwardToWarehouse from "./inventory/FGInwardToWarehouse";
import StockInward from "./inventory/StockInwards/StockInward";
import StockLedger from "./inventory/StockLedger";
import StockOutward from "../components/inventory/StockOutwards/StockOutward";
import StockStatus from "./inventory/StockStatus";
import StockOutwardView from "../components/inventory/StockOutwards/StockOutwardView";
import StockInwardView from "../components/inventory/StockInwards/StockInwardView";
import SalesTargetvsActual from "./crm/SalesTargetvsActual/SalesTargetvsActual";
import StockAdjustment from "./inventory/StockAdjustment/StockAdjustment";
import SalesReportTally from "./Sales/SalesReportTally";
// import StockAdjustmentView from "./inventory/StockAdjustment/StockAdjustmentView";
// import StockLedger from "./inventory/StockLedger/StockLedger";

const FormList = ({ name }) => {
  const classes = useStyles();
  switch (name) {
    case "Home":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Home />
          </div>
        </div>
      );
    case "Dashboard":
      return (
        <div className={classes.contentViewDash}>
          <Dashboard />
        </div>
      );
    case "Primary Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <PrimaryMaster />
          </div>
        </div>
      );
    case "Account":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Account />
          </div>
        </div>
      );
    case "User Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <UserMaster />
          </div>
        </div>
      );
    case "Account View":
      return (
        <div className={classes.contentView}>
          <AccountView />
        </div>
      );
    case "Lead View":
      return (
        <div className={classes.contentView}>
          <LeadView />
        </div>
      );
    case "Lead":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Lead />
          </div>
        </div>
      );
    case "Product Master":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Product />
          </div>
        </div>
      );
    case "Product View":
      return (
        <div className={classes.contentView}>
          <ProductMasterView />
        </div>
      );
    case "Opportunities":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Opportunities />
          </div>
        </div>
      );
    case "Quotation":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Quotation />
          </div>
        </div>
      );
    case "Quotation Analysis":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <QuotationAnalysis />
          </div>
        </div>
      );
    case "Quotation Analysis Country Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <QCountryWise />
          </div>
        </div>
      );
    case "Quotation Analysis Product Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <QProductWise />
          </div>
        </div>
      );
    case "Quotation Analysis Team Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <QTeamWise />
          </div>
        </div>
      );
    case "Quotation Lost Analysis":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <QuotationLostAnalysis />
          </div>
        </div>
      );
    case "Sales Order":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SalesOrder />
          </div>
        </div>
      );
    case "CRMTest":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CRMTest />
          </div>
        </div>
      );
    case "Activities":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Activities />
          </div>
        </div>
      );
    case "Customer Compaints":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CustomerCompaints />
          </div>
        </div>
      );
    case " Create Customer Compaints":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CreateCustomerCompaints />
          </div>
        </div>
      );
    case "Message Center":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <MessageCenter />
          </div>
        </div>
      );
    case "Sales":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Sales />
          </div>
        </div>
      );
    case "Delivery Challan":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <DeliveryChallan />
          </div>
        </div>
      );
    case "Dispatch Management":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <DispatchManagement />
          </div>
        </div>
      );
    case "Invoice":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Invoice />
          </div>
        </div>
      );
    case "SalesReportTally":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SalesReportTally />
          </div>
        </div>
      );
    case "Sales Analysis":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SalesAnalysis />
          </div>
        </div>
      );
    case "Sales Analysis Country Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <CountryWise />
          </div>
        </div>
      );
    case "Sales Analysis Product Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <ProductWise />
          </div>
        </div>
      );
    case "Sales Analysis Sales Team Wise":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SalesTeamWise />
          </div>
        </div>
      );
    case "Opportunity View":
      return (
        <div className={classes.contentView}>
          <OpportunityView />
        </div>
      );
    case "Quotation View":
      return (
        <div className={classes.contentView}>
          <QuotationView />
        </div>
      );
    case "Sales Order View":
      return (
        <div className={classes.contentView}>
          <SOMasterView />
        </div>
      );
    case "Delivery Challan View":
      return (
        <div className={classes.contentView}>
          <DCMasterView />
        </div>
      );
    case "Stock Outward View":
      return (
        <div className={classes.contentView}>
          <StockOutwardView />
        </div>
      );
    case "Stock Inward View":
      return (
        <div className={classes.contentView}>
          <StockInwardView />
        </div>
      );
    // case "Stock Adjustment View":
    //   return (
    //     <div className={classes.contentView}>
    //       <StockAdjustmentView />
    //     </div>
    //   );
    case "FG Inward To Warehouse":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <FGInwardToWarehouse />
          </div>
        </div>
      );
    case "Stock Inward":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <StockInward />
          </div>
        </div>
      );
    case "Stock Ledger":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <StockLedger />
          </div>
        </div>
      );
    // case "Stock Outward":
    //   return (
    //     <div>
    //       <div className={classes.header}>{name}</div>
    //       <div className={classes.content}>
    //         <StockOutward />
    //       </div>
    //     </div>
    //   );
    case "Stock Outward":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <StockOutward />
          </div>
        </div>
      );
    case "Stock Adjustment":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <StockAdjustment />
          </div>
        </div>
      );
    case "Stock Status":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <StockStatus />
          </div>
        </div>
      );
    case "Logistics":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Home />
          </div>
        </div>
      );
    case "Inventory":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <Home />
          </div>
        </div>
      );
    case "Sales Target vs Actual":
      return (
        <div>
          <div className={classes.header}>{name}</div>
          <div className={classes.content}>
            <SalesTargetvsActual />
          </div>
        </div>
      );
    default:
      return <div>Form Not Found Page to be displayed here</div>;
  }
};

const useStyles = makeStyles((theme) => ({
  html: {
    height: "100%",
  },
  body: {
    height: "100%",
    display: "flex",
  },
  header: {
    background: theme.palette.tertiary.gradient,
    color: "white",
    height: "2rem",
    paddingLeft: "1rem",
    fontSize: "1.3rem",
    marginTop: "5rem",
    marginBottom: "0.5rem",
    borderRadius: "0.5rem",
    position: "absolute",
    maxWidth: "100%",
    minWidth: "95%",
    flexGrow: 1,
  },
  content: {
    position: "absolute",
    marginTop: "7.5rem",
    maxWidth: "100%",
    minWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    flexGrow: 1,
  },
  contentView: {
    position: "absolute",
    marginTop: "0rem",
    maxWidth: "100%",
    minWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
  contentViewDash: {
    position: "absolute",
    marginTop: "5rem",
    maxWidth: "100%",
    minWidth: "95%",
    minHeight: "93%",
    marginRight: "1.5rem",
    // flexGrow: 1,
  },
}));

export default FormList;
